import { deduplicateAttendeesByEmail } from './attendee-id-utils';
import type { SerializedAttendee, SerializedTodoItem } from './schema';

/**
 * Check if an action item is completed
 */
export function isActionItemCompleted(item: SerializedTodoItem): boolean {
  return (
    (item.progress !== undefined && item.progress >= 100) ||
    (item.status?.toLowerCase().includes('done') ?? false) ||
    (item.status?.toLowerCase().includes('complete') ?? false)
  );
}

export function isActionItemDeleted(item: SerializedTodoItem): boolean {
  return typeof item.deletedAt === 'string' && item.deletedAt.length > 0;
}

/**
 * Deduplicate attendees by email with stable IDs
 * This delegates to the proper attendee-id-utils function
 */
export function deduplicateAttendees(attendees: SerializedAttendee[]): SerializedAttendee[] {
  return deduplicateAttendeesByEmail(attendees);
}

/**
 * Filter action items by completion status
 */
export function filterActionItemsByCompletion(
  items: SerializedTodoItem[],
  includeCompleted: boolean
): SerializedTodoItem[] {
  return includeCompleted
    ? items
    : items.filter(item => !isActionItemCompleted(item));
}

/**
 * Normalize a date value into an ISO string (YYYY-MM-DD or full ISO) for properties layer
 */
export function normalizeDateToIso(value: unknown): string | undefined {
  if (!value) return undefined;
  if (typeof value === 'string') {
    const parsed = Date.parse(value);
    return isNaN(parsed) ? undefined : new Date(parsed).toISOString();
  }
  if (value instanceof Date) return value.toISOString();
  if (typeof value === 'number') return new Date(value).toISOString();
  return undefined;
}
